

































































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { setErrorFromAxiosError } from '@/utils/helpers';
import { ISystemError } from '@/models/error/error.types';
import { Tag, ITag } from '@/models/configurator';
import { SystemError } from '@/models/error/error';

export default Vue.extend({
  name: 'QuestionTagPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Object, Number] as PropType<number | ITag>,
    externalErrorMessage: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      loading: false,
      error: null as ISystemError | null,
      search: ''
    };
  },

  computed: {
    ...mapGetters({
      getTags: 'configuratorQuestion/getTags'
    }),

    internalValue: {
      get(): ITag | number {
        return this.lazyValue;
      },
      set(val: ITag | number) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    tags(): ITag[] {
      return this.getTags;
    },

    latestTag(): ITag | undefined {
      const tag = this.tags[this.tags.length - 1];
      if (!tag) {
        return undefined;
      }
      return new Tag(tag);
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];
      if (this.externalErrorMessage) {
        errorList = this.externalErrorMessage;
      }
      if (this.error) {
        errorList.push(`${this.error.message} - ${this.error.detail}`);
      }

      return errorList;
    }
  },

  watch: {
    value: {
      handler(val) {
        this.lazyValue = val; // Sync lazyValue with the external prop value
      },
      immediate: true
    }
  },

  mounted() {
    this.loading = true;
    this.fetchTags()
      .catch(error => {
        this.error = setErrorFromAxiosError(error);
      })
      .finally(() => (this.loading = false));
  },

  methods: {
    ...mapActions({
      fetchTags: 'configuratorQuestion/fetchTags',
      createTag: 'configuratorQuestion/createTag'
    }),

    hoverListItemClass(hover: boolean) {
      return !this.search
        ? 'white grey--text'
        : hover
        ? 'primary white--text'
        : 'white primary--text';
    },

    /**
     * Custom filter is needed to search for list items
     */
    itemSearch(item: any, queryText: string, itemText: string) {
      return (
        (item.toString() || '')
          .toLowerCase()
          .indexOf((queryText || '').toLowerCase()) > -1
      );
    },

    addTag(withLabel: boolean) {
      let tagInstance: ITag | null = null;

      try {
        tagInstance = new Tag({
          name: this.search,
          is_label_required: withLabel
        });
      } catch (error) {
        if (SystemError.isSystemError(error)) {
          this.error = error;
        }
      }

      if (tagInstance != null) {
        this.loading = true;
        this.createTag(tagInstance)
          .then(() => {
            this.$emit('input', this.latestTag!.id);
            this.search = '';
            this.$nextTick(() => {
              (this.$refs['autocomplete'] as any).blur();
            });
          })
          .catch(error => {
            this.error = setErrorFromAxiosError(error);
          })
          .finally(() => (this.loading = false));
      }
    }
  }
});
